import { useParams } from "@tanstack/react-router";

export function useRouteParams() {
  const params = useParams({ strict: false });

  return [params] as const;
}
